// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* The title is a flex item with w-100 and the default min-width:auto, so it refuses to
   shrink below its longest word and squeezes the action button out. min-width:0 removes
   that floor and the title truncates instead. Scoped to headers that carry an action
   button, so headers without one keep their current long-title behaviour. */
.card-header.has-container-menu .title[data-v-68aed37e] {
	min-width: 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.modal-background[data-v-68aed37e] {
	z-index: 9999;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
